import React, {useEffect } from 'react'
import { gql, useMutation, useQuery } from '@apollo/client'
import Modal from 'styled-react-modal'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { FormattedMessage } from "react-intl"

import {
  Button,
  Input,
} from '../StyledComponents.js'
import {
  Wrapper,
} from '../StyledComponents.js'
import {loggedInContext} from '../auth/AuthContext'
import { useCsEvent } from '../client/useEvents.js'
import {toast} from 'react-toastify'
import Spinner from './Spinner'

const StyledModal = Modal.styled`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  background-color: white;
  border: .5em;
  border-style: solid;
  border-color: gray;
  padding: 1em;
  width: 85vw;
  @media(min-width: 960px) {
    width: 80vw;
  }
`
const Row = styled.div`
  position: relative;
  margin-top: 1em;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  @media(min-width: 960px) {
    width: 50%;
  }
`
const FormButton = styled(Button)`
    font-family: NeueEinstellungBold;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    font-size: 1rem;
    background-color: rgb(139, 125, 101);
    border: 0.1rem solid rgb(139, 125, 101);
    color: white;
    outline: 0px;
    display: block;
    font-weight: 500;
    margin: 0.5rem 0.5rem;
    padding: 0.5rem 0.5rem;

    :active {
      position: relative;
      top: 2px;
    }

    a {
      color: white;
    }
}
`
const ErrorDiv = styled.div`
    font-family: NeueEinstellungRegular;
    font-size: 1rem;
    line-height: 1;
    padding: 1rem;
    position: relative;
    margin-bottom: 1rem;
    color: rgb(219, 41, 41);
    border: 0.1rem solid rgb(219, 41, 41);
}
`

const addMutation = gql`
  mutation AddToCollection($id: String!, $item: JSONObject) {
    addToCollection(id: $id, item: $item)
  }
`

const collectionsQuery = gql`
  query Collections {
    me {
      collections {
        id,
        title
      }
    }
  }
`

function Component(props) {
  const {loggedIn, logIn, loginCta, openSignupModal} = React.useContext(loggedInContext) 
  const fireCsEvent = useCsEvent()

  const {item} = props

  const [createCollection, 
    {
      called, 
      loading: addLoading, 
      data: addData,
      error
    }
  ] = useMutation(addMutation, {
    onCompleted: (data) => {
      console.debug("Create collection on completed data:", data)
      if (data.addToCollection) {
        toast.success("Gazete sayfası koleksiyona eklendi.");
      } else {
        toast.error("Bir hata oldu. Lütfen daha sonra tekrar deneyin");
      }
      closeModal()
    },
    errorPolicy: 'all' 
  })

  const {loading, data} = useQuery(collectionsQuery, 
    {variables: {}})

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    props.onClose && props.onClose()
  }

  const onEkleClick = (id) => {
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Var olan collection seçildi"
    })
    createCollection({variables: {id, item}})

  }

  const onCreateNewClick = () => {
    closeModal()
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Yeni collection oluştur seçildi"
    })
    props.onCreate && props.onCreate()
  }

  return <StyledModal
    isOpen={true}
    afterOpen={afterOpenModal}
    onEscapeKeydown={closeModal}
    onBackgroundClick={closeModal}
    contentLabel="Add to collection"
  >
  <Wrapper>
    {loading || addLoading && <Spinner />}
    {!loading && !addLoading && <React.Fragment>
        <Row><h2>Bu sayfayı aşağıdaki koleksiyonlarınızdan birine ekleyin:</h2></Row>
        <Row>{data?.me?.collections?.map(item => {
          return <FormButton key={item.id} onClick={() => onEkleClick(item.id)}>
            {item.title}
          </FormButton>
        })}</Row>
        <Row>
          <h2>Veya yeni bir koleksiyon oluşturun</h2>
        </Row>
        <Row>
          <FormButton onClick={onCreateNewClick}>
            Yeni koleksiyon oluştur
          </FormButton>
        </Row>
      </React.Fragment>}
  </Wrapper>
  </StyledModal>
}

export default Component
